import Button from '@components/Button/Button';
import Popover, { positionBounded } from '@components/Popover/Popover';
import { ContentSection, TitleSection } from '@components/Popover/PopoverLayouts';

interface ProfilePictureDisabledPopoverProps {
  targetNode: HTMLElement | undefined;
  show: boolean | undefined;
  onClose: () => void;
}

const ProfilePictureDisabledPopover: React.FC<
  React.PropsWithChildren<ProfilePictureDisabledPopoverProps>
> = ({ targetNode, show, onClose }) => {
  return (
    <>
      <Popover
        positioner={positionBounded({ offsetX: 8, xPreference: 'right', alignY: 'cover' })}
        targetNode={targetNode}
        show={!!show}
        onClose={onClose}
        preventOutsideInteraction
        drawFocus={true}
      >
        <TitleSection text="Not Allowed" onClose={onClose} />
        <ContentSection>
          <div>
            <p style={{ paddingBottom: '20px' }}>Profile pictures cannot be added to card templates.</p>
            <Button onClick={onClose}>OK</Button>
          </div>
        </ContentSection>
      </Popover>
    </>
  );
};

export default ProfilePictureDisabledPopover;
